import { Box, useTheme, Button, TextField } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { motion } from "framer-motion";
import React, { useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { UserAuth } from "../context/AuthContext";
import Header from "./Header";
import TokenContext from "../context/TokenContext";
import { obtenerSubdisciplinas } from "../Redux/autocompletados";
import { miLegajo } from "../Redux/legajo";
import ModalSubdisciplina from "./modales/ModalSubdisciplina";
import { actualizarSubdisciplina } from "../Redux/formacion";

const AreaPrincipal = () => {
    const dispatch = useDispatch();
    const theme = useTheme();
    const token = useContext(TokenContext);
    const { empleado } = UserAuth();

    const [subdisciplinas, setSubdisciplinas] = React.useState([])
    const subDisciplinasSelector = useSelector(store => store.autocompletados.subdiciplinas)

    const [subDisciplina, setSubDisciplina] = React.useState('')
    const legajoSelector = useSelector(store => store.legajo.legajo)

    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    React.useEffect(() => {
        if (token, empleado) {
            dispatch(obtenerSubdisciplinas(token));
            dispatch(miLegajo(token, empleado.empleadoid))
        }
    }, [token, empleado]);

    React.useEffect(() => {
        if (subDisciplinasSelector.length > 0) {
            var array = []
            subDisciplinasSelector.forEach(element => {
                var objeto = {
                    label: element.new_name,
                    value: element.new_subdisciplinaid
                }
                array.push(objeto)
            });
            setSubdisciplinas(array)
        }
    }, [subDisciplinasSelector])

    React.useEffect(() => {
        if (legajoSelector.length > 0) {
            const item = legajoSelector[0]["_new_subdisciplina_value@OData.Community.Display.V1.FormattedValue"];
            setSubDisciplina(item);
        }
    }, [legajoSelector])

    const handleSubmit = (subDisciplina) => {
        dispatch(actualizarSubdisciplina(token, subDisciplina.new_subdisciplina.value, empleado.empleadoid ))
            .then(() => {
                dispatch(miLegajo(token, empleado.empleadoid))
                handleClose()
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    };

    return (
        <motion.div
            initial={{ opacity: 0, y: 100 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -100 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
        >
            <Box m="1.5rem 2.5rem">
                <Header
                    title={"Área principal de desempeño profesional"}
                />
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} sx={{ mt: 2 }}>
                        <Button onClick={handleOpen} color="secondary" variant="contained">Actualizar subdisciplina</Button>
                    </Grid>
                    <Grid item xs={12} sm={12} sx={{ mt: 2 }}>
                        <TextField color="secondary" label="Subdisciplina" value={subDisciplina || ''} InputProps={{ style: { fontWeight: 'bold' } }} fullWidth />
                    </Grid>
                </Grid>

                {/* MODAL PARA ACTUALIZAR SUBDISCIPLINAS */}
                <ModalSubdisciplina open={open} handleClose={handleClose} subdisciplinas={subdisciplinas} onSubmit={handleSubmit} />
            </Box>
        </motion.div>
    )
}

export default AreaPrincipal